export default function compareIds(a, b) {
  return Number(a) === Number(b);
}
